export const CHANNEL_PANEL_TAB_RECENT = 'recent'
export const CHANNEL_PANEL_TAB_SORTED = 'sorted'
export const CHANNEL_PANEL_TAB_NESTED = 'nested'

export const CHANNEL_PANEL_TABS = [
  CHANNEL_PANEL_TAB_RECENT,
  CHANNEL_PANEL_TAB_SORTED,
  CHANNEL_PANEL_TAB_NESTED,
]
